import script from "./AdminChatManager.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminChatManager.vue?vue&type=script&setup=true&lang=js"

import "./AdminChatManager.vue?vue&type=style&index=0&id=898a958a&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-898a958a"]])

export default __exports__